<template>
    <STextInput
        :name="fieldName"
        :input-data="text"
        :namespace="namespace"
        :key="namespace"
    />
</template>

<script>
import PopulationBoilerplate from '@/views/Admin/Config/Population/Fields/PopulationBoilerplate';

import STextInput from '@/views/Common/Input/STextInput';

export default {

    components: {
        STextInput,
    },
    mixins: [ PopulationBoilerplate ],

    data() {
        return {
            text: '',
        };
    },

    methods: {
        loadFieldData() {
            if (this.population) {
                this.text = this.population.text;
            }

            this.setFieldData();
        },

        setFieldData() {
            this.fieldData = {
                text: this.text,
            };

            this.storeFieldData();
        }
    },
};
</script>

